// AUTO-GENERATED by tools/generate-world4-v3.mjs. Do not edit by hand.
// Regenerate with: node tools/generate-world4-v3.mjs
// v3 harvests d=6 content unlocked by the IDA* transposition table.
import type { LevelDef } from '@tessera/engine';

export const WORLD_4_GENERATED: LevelDef[] = [
  // d*=5  branching=15.20  D=0.029  tiles=10
  {
    id: 'w4-l01',
    world: 4,
    index: 1,
    radius: 3,
    holes: [],
    objective: { kind: 'clear', moveBudget: 7 },
    tiles: [
    { coord: { q: -2, r: 3 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 0, r: -3 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 3, r: -1 }, color: 2, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 3, r: -3 }, color: 0 },
    { coord: { q: 1, r: -3 }, color: 0 },
    { coord: { q: 2, r: -3 }, color: 0 },
    { coord: { q: -3, r: 3 }, color: 1 },
    { coord: { q: -1, r: 3 }, color: 1 },
    { coord: { q: -3, r: 0 }, color: 2 },
    { coord: { q: -3, r: 2 }, color: 2 },
    ],
  },
  // d*=5  branching=12.94  D=0.031  tiles=10
  {
    id: 'w4-l02',
    world: 4,
    index: 2,
    radius: 3,
    holes: [],
    objective: { kind: 'clear', moveBudget: 7 },
    tiles: [
    { coord: { q: -1, r: -2 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 3, r: 0 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -3, r: 3 }, color: 2, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 0, r: 3 }, color: 0 },
    { coord: { q: 2, r: 1 }, color: 0 },
    { coord: { q: 1, r: 2 }, color: 0 },
    { coord: { q: -3, r: 2 }, color: 1 },
    { coord: { q: -3, r: 1 }, color: 1 },
    { coord: { q: 0, r: -3 }, color: 2 },
    { coord: { q: 3, r: -1 }, color: 2 },
    ],
  },
  // d*=6  branching=12.24  D=0.129  tiles=10
  {
    id: 'w4-l03',
    world: 4,
    index: 3,
    radius: 3,
    holes: [],
    objective: { kind: 'clear', moveBudget: 8 },
    tiles: [
    { coord: { q: 3, r: -2 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -3, r: 0 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -1, r: 3 }, color: 2, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -3, r: 3 }, color: 0 },
    { coord: { q: -3, r: 1 }, color: 0 },
    { coord: { q: -3, r: 2 }, color: 0 },
    { coord: { q: 0, r: 3 }, color: 1 },
    { coord: { q: 3, r: -3 }, color: 1 },
    { coord: { q: 2, r: -3 }, color: 2 },
    { coord: { q: 1, r: -3 }, color: 2 },
    ],
  },
  // d*=6  branching=18.25  D=0.197  tiles=10
  {
    id: 'w4-l04',
    world: 4,
    index: 4,
    radius: 3,
    holes: [],
    objective: { kind: 'clear', moveBudget: 8 },
    tiles: [
    { coord: { q: 3, r: -3 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -3, r: 3 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 1, r: 1 }, color: 2, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -3, r: 1 }, color: 0 },
    { coord: { q: -3, r: 0 }, color: 0 },
    { coord: { q: -3, r: 2 }, color: 0 },
    { coord: { q: 3, r: -1 }, color: 1 },
    { coord: { q: 0, r: -3 }, color: 1 },
    { coord: { q: -1, r: -2 }, color: 2 },
    { coord: { q: -2, r: -1 }, color: 2 },
    ],
  },
  // d*=6  branching=14.35  D=0.208  tiles=10
  {
    id: 'w4-l05',
    world: 4,
    index: 5,
    radius: 3,
    holes: [],
    objective: { kind: 'clear', moveBudget: 8 },
    tiles: [
    { coord: { q: 1, r: 2 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -2, r: -1 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 3, r: -3 }, color: 2, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -3, r: 0 }, color: 0 },
    { coord: { q: 0, r: -3 }, color: 0 },
    { coord: { q: -1, r: -2 }, color: 0 },
    { coord: { q: 3, r: 0 }, color: 1 },
    { coord: { q: 2, r: 1 }, color: 1 },
    { coord: { q: -1, r: 3 }, color: 2 },
    { coord: { q: 0, r: 3 }, color: 2 },
    ],
  },
  // d*=6  branching=21.35  D=0.283  tiles=11
  {
    id: 'w4-l06',
    world: 4,
    index: 6,
    radius: 3,
    holes: [],
    objective: { kind: 'clear', moveBudget: 8 },
    tiles: [
    { coord: { q: -3, r: 1 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 3, r: -2 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 0, r: 3 }, color: 2, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 3, r: 0 }, color: 0 },
    { coord: { q: 3, r: -1 }, color: 0 },
    { coord: { q: 3, r: -3 }, color: 0 },
    { coord: { q: -3, r: 0 }, color: 1 },
    { coord: { q: -3, r: 2 }, color: 1 },
    { coord: { q: -3, r: 3 }, color: 1 },
    { coord: { q: 1, r: -3 }, color: 2 },
    { coord: { q: -1, r: -2 }, color: 2 },
    ],
  },
  // d*=6  branching=20.75  D=0.293  tiles=10
  {
    id: 'w4-l07',
    world: 4,
    index: 7,
    radius: 3,
    holes: [],
    objective: { kind: 'clear', moveBudget: 8 },
    tiles: [
    { coord: { q: 3, r: -2 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -3, r: 3 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 0, r: -3 }, color: 2, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -3, r: 0 }, color: 0 },
    { coord: { q: -3, r: 2 }, color: 0 },
    { coord: { q: -3, r: 1 }, color: 0 },
    { coord: { q: 3, r: -3 }, color: 1 },
    { coord: { q: 2, r: -3 }, color: 1 },
    { coord: { q: -1, r: 3 }, color: 2 },
    { coord: { q: -2, r: 3 }, color: 2 },
    ],
  },
  // d*=7  branching=17.10  D=0.401  tiles=11
  {
    id: 'w4-l08',
    world: 4,
    index: 8,
    radius: 3,
    holes: [],
    objective: { kind: 'clear', moveBudget: 9 },
    tiles: [
    { coord: { q: -1, r: -2 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 3, r: 0 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -3, r: 3 }, color: 2, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 2, r: 1 }, color: 0 },
    { coord: { q: 1, r: 2 }, color: 0 },
    { coord: { q: 0, r: 3 }, color: 0 },
    { coord: { q: -3, r: 1 }, color: 1 },
    { coord: { q: 0, r: -3 }, color: 1 },
    { coord: { q: -3, r: 0 }, color: 1 },
    { coord: { q: 1, r: -3 }, color: 2 },
    { coord: { q: 3, r: -2 }, color: 2 },
    ],
  },
  // d*=7  branching=18.85  D=0.411  tiles=11
  {
    id: 'w4-l09',
    world: 4,
    index: 9,
    radius: 3,
    holes: [],
    objective: { kind: 'clear', moveBudget: 9 },
    tiles: [
    { coord: { q: 1, r: 2 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -3, r: 0 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 3, r: -3 }, color: 2, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -2, r: -1 }, color: 0 },
    { coord: { q: -1, r: -2 }, color: 0 },
    { coord: { q: 0, r: -3 }, color: 0 },
    { coord: { q: 0, r: 3 }, color: 1 },
    { coord: { q: 3, r: -1 }, color: 1 },
    { coord: { q: 3, r: 0 }, color: 1 },
    { coord: { q: -3, r: 1 }, color: 2 },
    { coord: { q: -3, r: 3 }, color: 2 },
    ],
  },
  // d*=7  branching=19.89  D=0.418  tiles=11
  {
    id: 'w4-l10',
    world: 4,
    index: 10,
    radius: 3,
    holes: [],
    objective: { kind: 'clear', moveBudget: 9 },
    tiles: [
    { coord: { q: 0, r: 3 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -3, r: 0 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 3, r: -3 }, color: 2, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 0, r: -3 }, color: 0 },
    { coord: { q: 1, r: -3 }, color: 0 },
    { coord: { q: -1, r: -2 }, color: 0 },
    { coord: { q: 2, r: 1 }, color: 1 },
    { coord: { q: 1, r: 2 }, color: 1 },
    { coord: { q: 3, r: -2 }, color: 1 },
    { coord: { q: -3, r: 1 }, color: 2 },
    { coord: { q: -2, r: 3 }, color: 2 },
    ],
  },
];
